import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconThumbtack: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconThumbtack"><Path d="M12 14.5H4.5V12L4.89134 11.6739C6.54428 10.2964 7.5 8.25594 7.5 6.10428V2.5H16.5V6.10428C16.5 8.25594 17.4557 10.2964 19.1087 11.6739L19.5 12V14.5H12ZM12 14.5V21.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconThumbtack;
